import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "left"
};
var _hoisted_2 = {
  key: 0,
  class: "right"
};
import tabItem from './lib/tabItem';
import { ref } from 'vue';
export default {
  __name: 'analysisTab',
  props: {
    // tabOptions: {
    //   type: Array,
    //   default: () => [],
    // },
    isFlex: {
      type: Boolean,
      default: false
    },
    showTab: {
      type: Boolean,
      default: true
    }
  },
  emits: ['tabChange'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var activeTab = ref(1);
    var tabOptions = [{
      label: '发起课堂数',
      value: 1,
      content: '课堂互动平台授课的授课总数'
    }, {
      label: '调用学程课堂数',
      value: 2,
      content: '周期内的总授课次数'
    }, {
      label: '发起展示课堂数',
      value: 3,
      content: '周期内使用展示功能进行的课堂次数'
    }, {
      label: '展示学生参与率',
      value: 4,
      content: '周期内参与展示活动的学生比例'
    }, {
      label: '资源推送课次率',
      value: 5,
      content: '周期内使用资源推送功能的课堂比例'
    }, {
      label: '有效评价课次率',
      value: 6,
      content: '周期内有效进行评价的课堂比例',
      placement: 'bottom-right'
    }];
    var handleClick = function handleClick(tab) {
      activeTab.value = tab.value;
      emits('tabChange', tab);
    };
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["tab-analysis", {
          flex: __props.isFlex
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_svg_icon, {
        size: "28",
        name: "db-analys"
      }), _createElementVNode("span", null, [_renderSlot(_ctx.$slots, "title", {}, function () {
        return [_cache[0] || (_cache[0] = _createTextVNode("对比分析", -1))];
      })])]), __props.showTab ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_renderSlot(_ctx.$slots, "right-slot", {}, function () {
        return [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabOptions, function (item, index) {
          return _createVNode(_unref(tabItem), {
            key: index,
            toolContent: item.content,
            placement: item.placement,
            class: _normalizeClass({
              active: activeTab.value === item.value
            }),
            onClick: function onClick($event) {
              return handleClick(item);
            }
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(item.label), 1)];
            }),
            _: 2
          }, 1032, ["toolContent", "placement", "class", "onClick"]);
        }), 64))];
      })])) : _createCommentVNode("", true)], 2);
    };
  }
};